<template lang="pug">
md-layout(md-flex="100")
    .md-headline Subtitles
    md-layout.info-subtitles-container(md-flex="100")
        md-layout(v-if="subtitlesProp.length > 0")
            div.linkSubtitles(v-for="subtitle in subtitlesProp")
                span This video has subtitles. 
                a(:href="'//'+subtitleBucketName+'/'+subtitle.path", target="_blank", rel="noopener noreferrer") Click here to open
        div(md-flex='50')
            md-button.md-primary.md-raised#deleteBtn( @click="deleteSubtitle", v-if="subtitlesProp.length > 0")
                | delete
            md-button.md-primary.md-raised( @click="showSubtitlesHandle" )
                | {{textButtonSubtitle()}}

    loader(:loading='true', :size='40', v-if="loading && showSubtitles")
    md-layout.lang-container(md-flex="100", v-if="!loading && showSubtitles")
        md-layout.options(md-flex="10")
            md-select(v-model="subtitles.language", placeholder="Select language")
                md-option(v-for="language in availableLanguages" :key="language.code" :value="language.code")
                    | {{ language.name }}
        md-layout(md-flex="40")
            md-input-container()
                label Select file to upload
                md-file(
                    type="file",
                    accept=".srt",
                    @selected="onSrtJobFileSelected",
                )
        md-button.md-icon-button.md-raised(@click='handleSubtitleUpload', :disabled="!uploadFile")
            md-icon(md-iconset="fa fa-cloud-upload-alt")
    div.container-info(v-if="isEditMode && changeProp")
        md-icon.icon-info(md-iconset="fa fa-info")
        p.check-properties() Changes will be applied when you click update.

</template>

<script>
import uploadService from '../../services/uploadService';
import { mapState } from 'vuex';
import Loader from '../Loader.vue'

export default {
components:{
    Loader

},
props: {
    subtitlesProp: {
        type: Array,
        required: false,
        default: [],
    },
    isEditMode:{
        type: Boolean,
        required: false,
        default: false,
    }
},
data() {
    return {
        subtitleBucketName: process.env.SUBTITLES_BUCKET_NAME.replace('-rhebus-works', '.rhebus.works'),
        availableLanguages: [
            { name: "English", code: "en" },
        ],
        subtitles: {
            language: 'en',
            file: null,
        },
        showSubtitles: false,
        uploadFile: false,
        loading: false,
        changeProp: false,
        isFirstLoad: true,
    };
},

computed: {
    ...mapState({
            accountID: (state) => state.user.siteuser.user_metadata.account_id,
        }),
},

methods: {
    showSubtitlesHandle(){
        this.showSubtitles = !this.showSubtitles;
    },
    textButtonSubtitle() {
        return this.showSubtitles ? 'Cancel' : this.subtitlesProp.length > 0 ? 'Change subtitle file' : 'Add subtitle';
    },

    onSrtJobFileSelected(files) {
        if (!files || files.length === 0) {
            return;
        }

        const file = files[0];
        if (!/\.(srt)$/i.test(file.name)) {
            alert("Please select a valid .srt file.");
            return;
        }
        this.uploadFile = true;
        this.subtitles.file = file;
    },

    async handleSubtitleUpload() {
        this.uploadFile = false;
        this.loading = true;
        if (!this.subtitles.file) {
            alert("No subtitle file selected.");
            return;
        }
        if (!this.subtitles.language) {
            alert("No language selected.");
            return;
        }
        const uploadUrl = await uploadService.uploadSubtitles(this.subtitles, this, this.accountID);
        this.$emit('subtitle-uploaded', {language: this.subtitles.language, path: uploadUrl});
        this.showSubtitles = false;
        this.loading = false;
    },
    deleteSubtitle(){
        this.$emit('delete-subtitle');
    }
},
watch:{
    subtitlesProp() {
        if (this.isFirstLoad) {
            this.isFirstLoad = false;
        } else {
            this.changeProp = true;
        }
    }
}
}
</script>

<style lang="scss" scoped>
md-select {
    margin: 10px 0;
}

md-button {
    margin-top: 20px;
}

.lang-container {
    display: flex;
    align-items: center;
    justify-content: center;
}
.options {
    margin-right: 30px;
}

.subtitleAddChange {
    display: flex;
    align-items: center;
    gap: 20px;
}

.linkSubtitles a {
    font-size: 1.1em;
    font-style: italic;
}

.info-subtitles-container {
    display: flex;
    align-items: center;
    justify-content: space-between;

}

.check-properties {
    font-style: italic;
    color: gray;
    font-weight: 500;
}
.container-info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.icon-info {
    justify-content: center;
    margin: 0 10px 0 0;
    font-size: small;
    background-color: #4ea9dd;
    border-radius: 50%;
}

#deleteBtn {
    background-color: rgb(234,67,53)!important;
    &:hover{
        background-color: rgb(234,67,53,.8) !important;
    }
}

</style>



// WEBPACK FOOTER //
// src/shared-components/upload/SubtitleUploader.vue